import { EventAttendeeRoles } from 'src/app/global.constants';

export const PAYABLE_CREW_ROLES = new Set<string>([
    EventAttendeeRoles.crewLead,
    EventAttendeeRoles.assistantCrewLead,
    EventAttendeeRoles.crewMember,
]);

export const CREW_PAY_COLUMN_KEYS = [
    'unpacking', 'packing', 'crewLead', 'flatRate', 'load', 'unload', 'bonus',
] as const;

export type CrewPayColumnKey = typeof CREW_PAY_COLUMN_KEYS[number];

export const CREW_PAY_CALC_KEYS: Record<CrewPayColumnKey, string> = {
    unpacking: 'fpLabor_unpackingLaborPerMan',
    packing:   'fpLabor_packingLaborPerMan',
    crewLead:  'fpLabor_crewLead',
    flatRate:  'fpLabor_flatRatePerMan',
    load:      'fpLabor_loadPerMan',
    unload:    'fpLabor_unloadPerMan',
    bonus:     'fpLabor_bonusPerMan',
} as const;

// Requirement: `#7194` - the columns where the member ticked as Crew Lead is paid the lead's share
// instead of the regular per-man figure. Only calculator versions from 2611.03.0 output these keys;
// older versions pay the lead like everyone else, so a missing key falls back to the regular figure.
export const CREW_PAY_CREW_LEAD_CALC_KEYS: Partial<Record<CrewPayColumnKey, string>> = {
    load:   'fpLabor_crewLeadLoad',
    unload: 'fpLabor_crewLeadUnload',
} as const;
